var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34182 9.60174L1.20082 2.18174C1.07214 2.05131 1 1.87546 1 1.69224C1 1.50902 1.07214 1.33317 1.20082 1.20274C1.26409 1.13849 1.33951 1.08747 1.42269 1.05264C1.50587 1.01781 1.59514 0.999878 1.68532 0.999878C1.77549 0.999878 1.86477 1.01781 1.94794 1.05264C2.03112 1.08747 2.10654 1.13849 2.16982 1.20274L9.99982 9.11074C10.1285 9.24117 10.2006 9.41702 10.2006 9.60024C10.2006 9.78346 10.1285 9.95931 9.99982 10.0897L2.16982 17.9977C2.10654 18.062 2.03112 18.113 1.94794 18.1478C1.86477 18.1827 1.77549 18.2006 1.68532 18.2006C1.59514 18.2006 1.50587 18.1827 1.42269 18.1478C1.33951 18.113 1.26409 18.062 1.20082 17.9977C1.07214 17.8673 1 17.6915 1 17.5082C1 17.325 1.07214 17.1492 1.20082 17.0187L8.34182 9.60174Z",
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/right-icon.42f38770baa2c38dbaee7a335f8d7c3f.svg";
export { ForwardRef as ReactComponent };